<template>
    <div class="part-tinymce">
      <tinymce-vue v-model="content" :init="init" :disabled="disabled" @onClick="onClick" />
    </div>
  </template>
  
  <script>
    //引入tinymce编辑器
    import tinymceVue from '@tinymce/tinymce-vue'
  
    //引入node_modules里的tinymce相关文件文件
    import tinymce from 'tinymce/tinymce' //tinymce默认hidden，不引入则不显示编辑器
    import 'tinymce/themes/silver' //编辑器主题，不引入则报错
    import 'tinymce/icons/default' //引入编辑器图标icon，不引入则不显示对应图标
  
    // 引入编辑器插件（基本免费插件都在这儿了）
    // 文件
    import 'tinymce/plugins/preview' //预览（菜单、工具）
    import 'tinymce/plugins/print' //打印（菜单）
  
    // 编辑
    import 'tinymce/plugins/searchreplace' //查找替换（菜单）
  
    // 视图
    import 'tinymce/plugins/code' //编辑源码（菜单、工具）
    import 'tinymce/plugins/fullscreen' //全屏（菜单、工具）
  
    // 插入
    import 'tinymce/plugins/image' //插入编辑图片（菜单、工具）
    import 'tinymce/plugins/link' //超链接（菜单、工具）
    import 'tinymce/plugins/media' //插入编辑媒体（菜单）
    import 'tinymce/plugins/table' //表格（菜单、工具）
    import 'tinymce/plugins/charmap' //特殊字符（菜单）
    import 'tinymce/plugins/hr' //水平分割线（菜单）
    import 'tinymce/plugins/pagebreak' //插入分页符（菜单）
    import 'tinymce/plugins/nonbreaking' //插入不间断空格（菜单）
    import 'tinymce/plugins/anchor' //锚点（菜单）
    import 'tinymce/plugins/insertdatetime' //插入日期时间（菜单）
  
    // 工具
    import 'tinymce/plugins/wordcount' //字数统计（菜单）
  
    // 只在工具栏出现
    import 'tinymce/plugins/directionality' //文字方向（工具）
    import 'tinymce/plugins/lists' //列表插件（工具）
  
    // 自动
    import 'tinymce/plugins/advlist' //高级列表（自动）
    import 'tinymce/plugins/autolink' //自动链接（自动）
    import 'tinymce/plugins/paste' //粘贴插件（自动）
  
    // 不使用
    import 'tinymce/plugins/autosave' //自动存稿（不使用）
    import 'tinymce/plugins/autoresize' //编辑器高度自适应,注：plugins里引入此插件时，Init里设置的height将失效（不使用）
    import 'tinymce/plugins/codesample' //代码示例（不使用）
    import 'tinymce/plugins/emoticons' //表情（不使用）
    import 'tinymce/plugins/fullpage' //文档属性（不使用）
    import 'tinymce/plugins/help' //帮助（不使用）
    import 'tinymce/plugins/importcss' //引入css（不使用）
    import 'tinymce/plugins/save' //保存（不使用）
    // import 'tinymce/plugins/spellchecker'  //拼写检查，暂未加入汉化，不建议使用（不使用）
    import 'tinymce/plugins/tabfocus' //切入切出，按tab键切出编辑器，切入页面其他输入框中（不使用）
    import 'tinymce/plugins/template' //内容模板（不使用）
    import 'tinymce/plugins/textcolor' //文字颜色（不使用）
    import 'tinymce/plugins/textpattern' //快速排版（不使用）
    import 'tinymce/plugins/toc' //目录生成器（不使用）
    import 'tinymce/plugins/visualblocks' //显示元素范围（不使用）
    import 'tinymce/plugins/visualchars' //显示不可见字符（不使用）
    import 'tinymce/plugins/quickbars' //快速工具栏（不使用）
  
    export default {
      name: 'partTinymce',
      components: {
        tinymceVue
      },
      props: {
        value: {
          type: String,
          default: ''
        },
        disabled: {
          type: Boolean,
          default: false
        },
        plugins: {
          type: [String, Array],
          default: () => {
            return 'preview print searchreplace code fullscreen image link media table charmap hr pagebreak nonbreaking anchor insertdatetime wordcount directionality lists advlist autolink paste'
          }
        },
        toolbar: {
          type: [String, Array],
          default: () => {
                      return [
              'undo redo | preview code fullscreen | image link table | alignleft aligncenter alignright alignjustify outdent indent | bullist numlist | cut copy paste pastetext',
              'forecolor backcolor bold italic underline strikethrough removeformat | styleselect fontselect fontsizeselect lineheight selectall',
            ]
                  }
        },
      },
      data() {
        return {
          content: this.value,
          init: {
            language: 'zh_CN', //语言类型
            language_url: '/tinymce/zh_CN.js', //引入语言包文件
            skin_url: '/tinymce/skins/ui/tinymce-5', //皮肤：浅色
            plugins: this.plugins, //插件配置
            toolbar: this.toolbar, //工具栏配置，设为false则隐藏
            height: 400, //注：引入autoresize插件时，此属性失效
            placeholder: '请输入内容，若需要插入源代码，请选择<>符号插入源代码',
            fontsize_formats: '16px 0.24rem 0.28rem 0.32rem 0.36rem 0.4rem 0.44rem 0.48rem 0.52rem 0.56rem 0.6rem 0.64rem 0.68rem 0.72rem 0.76rem 0.8rem', //字体大小
            font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;', //字体样式
            lineheight_formats: "1 1.2 1.5 1.75 2", //行高配置，也可配置成"12px 14px 16px 20px"这种形式
            
            convert_urls: false, //自动转换URL
            paste_data_images: true, //图片是否可粘贴
            branding: false, //tiny技术支持信息是否显示
            elementpath: true, //元素路径是否显示
            resize: false, //编辑器宽高是否可变，false-否,true-高可变，'both'-宽高均可，注意引号
          },
        }
      },
      watch: {
        value(v) {
          this.content = v
        },
        content(v) {
          this.$emit('input', v)
        },
      },
      mounted() {
        tinymce.init({})
      },
      methods: {
        // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
        onClick(e) {
          this.$emit('onClick', e, tinymce)
        },
        //清空内容
        clear() {
          this.content = ''
        }
      }
    }
  </script>
  <style>
  .tox-tinymce-aux{
    z-index: 9999 !important;
  }</style>
  